import posthog from 'posthog-js';
import { siteConfig } from '../../config/siteConfig';

// Keep init idempotent (React StrictMode mounts twice in dev)
declare global {
  interface Window {
    __POSTHOG_INIT__?: boolean;
  }
}

const isProd = process.env.NODE_ENV === 'production';

// CRA env vars (preferred). Fallbacks keep local working if env isn’t wired yet.
const POSTHOG_KEY =
  process.env.REACT_APP_POSTHOG_KEY || 'phc_ivfLEl4B7i3VK02OSvyTnmU9vdbdaQs2AlyeaLk4IQ6';

const POSTHOG_HOST =
  process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';

export function initPosthog() {
  if (siteConfig.ctx !== 'nyc') return;   // only track NYC
  if (typeof window === 'undefined') return;
  if (window.__POSTHOG_INIT__) return;
  window.__POSTHOG_INIT__ = true;

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    // projectid: '264011'

    // Keep it aligned with GA: we’ll send pageviews manually based on ?page=
    capture_pageview: false,

    // Useful “confusion”/UX signals + basic autocapture (clicks, etc.)
    autocapture: true,

    // PROD: keep identified-only (privacy + less noise)
    // DEV: allow profiles so you can see Live Events without thinking about identity
    person_profiles: isProd ? 'identified_only' : 'always',

    // Optional; leaving session replay enabled if you want it available later.
    // (PostHog also has project-level toggles, so this is not the only control.)
    disable_session_recording: false,

    // Optional: helps keep your own dev traffic out of prod dashboards if you want
    // loaded: (ph) => { if (!isProd) ph.debug(true) },
  });
  // Attach site context to every future event automatically
  posthog.register({ site: siteConfig.ctx });
  // DEV ONLY: identify so events show up immediately when project is “identified only”
  // In PROD, you should call identify() only when you actually know who the user is.
  if (!isProd) {
    posthog.identify('dev-localhost-user');
  }
}

export function capturePageview(path: string, props?: Record<string, any>) {
  if (siteConfig.ctx !== 'nyc') return;
  if (typeof window === 'undefined') return;

  posthog.capture('$pageview', {
    page: path,                 // friendly
    $pathname: path,            // PostHog-ish
    $current_url: window.location.href,
    ...props,
  });
}

// Capture event boiler plate.
// posthog.capture('my event', { property: 'value' })
export { posthog };
